// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import Icon_use_cases from '../../img/icons/24/color/use-cases.svg';
import Icon_docs from '../../img/icons/24/color/book.svg';
import Icon_blog from '../../img/icons/24/color/blog.svg';
import Icon_solutions from '../../img/icons/24/color/puzzle.svg';
import Icon_faq from '../../img/icons/24/color/faq.svg';
import {useHistory} from 'react-router-dom';
import styles from './products.module.less';
import {get_new_link} from '../../../../hola/pub/lib/use_pathname';

type t_resource_type = 'use_cases' | 'proxy_solutions' | 'documentation'
    | 'blog' | 'faq';

interface i_resource_info {
    title: string;
    text: string;
    icon: JSX.Element;
    to: string;
}

const resources_info: Record<t_resource_type, i_resource_info> = {
    faq: {
        title: 'FAQ',
        text: 'Search our knowledge base for answers to common questions.',
        icon: <Icon_faq/>,
        to: '/faq',
    },
    use_cases: {
        title: 'Use Cases',
        text: 'Find the perfect proxy infrastructure for your business case.',
        icon: <Icon_use_cases/>,
        to: '/use-cases',
    },
    proxy_solutions: {
        title: 'Proxy Solutions',
        text: 'Oculus proxies seamlessly integrate with leading third party'+
          ' software.',
        icon: <Icon_solutions/>,
        to: '/proxy-solutions',
    },
    documentation: {
        title: 'Documentation',
        text: 'Explore Oculus API documents and resources.',
        icon: <Icon_docs/>,
        to: 'https://docs.oculusproxies.com/',
    },
    blog: {
      title: 'Blog',
      text: 'News, tutorials, and product updates for high-success proxies.',
      icon: <Icon_blog/>,
      to: '/blog',
  },
};

interface i_resource_card_props {
    resource: t_resource_type;
}

export const Resource_card = (props: i_resource_card_props)=>{
    const {resource} = props;
    const history = useHistory();
    const {theme} = use_theme({def: 'oculus'});
    const card_cls = cn(styles.product_card, styles[resource], styles.info);
    const r = resources_info[resource];
    return <div className={card_cls}
      onClick={()=>{
        if (r.to.startsWith('https://'))
          window.open(r.to, '_blank');
        else
          history.push(r.to);
      }}>
      <div className={styles.img}>{r.icon}</div>
      <div className={styles.content}>
        <a href={r.to.startsWith('https://') ? r.to : get_new_link(r.to)}
          className={cn(theme.P, theme.p14, theme.bold, styles.title)}
          target={r.to.startsWith('https://') ? '_blank' : undefined}
          rel={r.to.startsWith('https://') ? 'noopener noreferrer' :
            undefined}>
          {r.title}
        </a>
        <p className={cn(theme.p12, theme.med, styles.pt)}>
          {r.text}
        </p>
      </div>
    </div>;
};

export const Resources_menu = ()=>{
    return <div className={styles.products_menu}>
      <div className={styles.group}>
        <div className={styles.items}>
          <Resource_card resource='faq'/>
          <Resource_card resource='documentation'/>
        </div>
      </div>
      <div className={styles.group_separator}/>
      <div className={styles.group}>
        <div className={styles.items}>
          <Resource_card resource='proxy_solutions'/>
          <Resource_card resource='use_cases' />
        </div>
      </div>
      <div className={styles.group_separator}/>
      <div className={styles.group}>
        <div className={styles.items}>
          <Resource_card resource='blog'/>
        </div>
      </div>
    </div>;
};
